// extracted by mini-css-extract-plugin
export default {"icon":"u96sF","icon__image":"qgblM","icon__image_mode_mask":"rDlwv","icon__image_mode_background":"cLwmQ"};